import {InvoiceEventCategory} from "./InvoiceEventTypeObject";

/**
 * Invoice event category type object model.
 */
export default class InvoiceEventCategoryType {
	constructor(public readonly id: string) {}

	/**
	 * Convert string to InvoiceEventCategoryType.
	 * @param {string} string
	 * @return {InvoiceEventCategoryType}
	 */
	public static fromString(string: string): InvoiceEventCategoryType {
		return new InvoiceEventCategoryType(string)
	}

	public static getAllCategories(): InvoiceEventCategoryType[] {
		const result: InvoiceEventCategoryType[] = [];
		for (let key in InvoiceEventCategory) {
			// filter out "All" value - MultiSelectDropDown already has it
			if (key !== InvoiceEventCategory.All) {
				result.push(InvoiceEventCategoryType.fromString(InvoiceEventCategory[key]));
			}
		}
		return result;
	}

	getLabel() {
		return this.id;
	}
}